import React, {Fragment, useContext} from 'react';
import PropTypes from 'prop-types';
import {TravelerTimeline} from '@homeaway/react-traveler-timeline';
import {Waypoint} from '@homeaway/react-unveil';
import CancellationPolicy from '../CancellationPolicy/CancellationPolicy';
import ManageBookingSection from '../../ManageBookingSection/ManageBookingSection';
import CancelTripModalContainer from '../CancelTripModalContainer/CancelTripModalContainer';
import FlexibleDates from './FlexibleDates/FlexibleDates';
import SystemContext from '../../../../../context/SystemContext';
import {
    triggerGenericEvent,
    TRIP_DETAILS,
} from '../../../../../../utils/EDAP/ConversationDetails';
import translate from '../../../../../../utils/translations';

const CancelBooking = (props) => {
    const {
        system: {isMobile},
    } = useContext(SystemContext);
    const {
        data,
        isFlexibleDates,
        isCancellationRequested,
        sectionTitle,
        translations,
    } = props;
    const {
        getTravelerStay: {
            stayState: {
                currentStateOfStay: {actions},
                stateOfStayData,
            },
        },
    } = data;

    const cancellationPolicy = stateOfStayData?.cancellationPolicies || {};
    const allowedActions = actions?.map((action) => action.id) || [];
    const {
        cancellationPolicyPeriods = [],
        cancellationTimelinePeriods = [],
        unstructuredPolicyFreeText,
    } = cancellationPolicy;
    const hasMultipleCancellationPeriods = cancellationPolicyPeriods.length > 1;

    const renderPolicyWithCancelByMessage = () => (
        <div className={'policy-with-message'}>
            <CancellationPolicy
                policies={cancellationPolicyPeriods}
                sectionTitle={sectionTitle}
                unstructuredPolicyFreeText={unstructuredPolicyFreeText}
            />
            {hasMultipleCancellationPeriods &&
                translate(
                    props.translations,
                    'traveler/ces',
                    'messages',
                    'cancellation.cko.addendum'
                )}
        </div>
    );

    function onWaypointEnter() {
        triggerGenericEvent({
            actionlocation: TRIP_DETAILS,
            appname: 'stay-ui',
            eventcategory: 'trip details page',
            eventaction: 'page scroll',
            eventlabel: 'modify_cancel_policy',
        });
    }

    return (
        <Waypoint onEnter={onWaypointEnter}>
            <ManageBookingSection data-testid="manage-booking-cancel-booking">
                <div className="CancelSection__section-content-container CancelSection__section-content-container__policy">
                    <Fragment>
                        {renderPolicyWithCancelByMessage()}
                        {!!cancellationTimelinePeriods.length && (
                            <TravelerTimeline
                                isVertical={isMobile}
                                timelinePeriods={cancellationTimelinePeriods}
                            />
                        )}
                    </Fragment>
                    {isFlexibleDates && !isCancellationRequested ? (
                        <FlexibleDates
                            allowedActions={allowedActions}
                            translations={translations}
                        />
                    ) : null}
                    <CancelTripModalContainer {...props} />
                </div>
            </ManageBookingSection>
        </Waypoint>
    );
};

export default CancelBooking;

CancelBooking.propTypes = {
    cancellationPolicyPeriods: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
        })
    ),
    timelinePeriods: PropTypes.arrayOf(
        PropTypes.shape({
            timelineLabel: PropTypes.string,
            refundWindowLabel: PropTypes.string.isRequired,
            shortDateLocalized: PropTypes.string,
            isActive: PropTypes.bool.isRequired,
            isPast: PropTypes.bool.isRequired,
            iconCode: PropTypes.string,
        })
    ).isRequired,
    translations: PropTypes.shape({}),
    unstructuredPolicyFreeText: PropTypes.string,
};

CancelBooking.defaultProps = {
    translations: {},
    unstructuredPolicyFreeText: '',
};
